import {Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { ImporterType } from "../../../../objects/calculator/public/types/type";
import { OrderOptions } from "../../../../objects/orders/orderOptions";
import { ActivatedRoute, Router } from "@angular/router";
import { FormHelper } from "../../../../common/helpers/formHelper";
import { GoogleTagService } from "../../../../services/google-tag.service";
import { OrderItem } from "../../../../objects/orders/orderItem";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import {HowCarryingComponent} from "./carrying/how-carrying.component";
import {ShipmentFromTabComponent} from "./shipment-from-tab/shipment-from-tab.component";
import {ModalDirective, BsModalService, BsModalRef} from "ngx-bootstrap";

@Component({
    selector: "public-calculator-v2",
    templateUrl: "./public-calculator-v2.component.html",
    moduleId: module.id.toString()
})
export class PublicCalculatorV2Component implements OnInit {

    @Input()
    public order: Order = new Order();
    public orderItem: OrderItem = new OrderItem();

    public importerTypeRef = ImporterType;
    public firstPageHide: boolean = true;

    public showWizard: boolean = true;
    public showFirstTab: boolean = true;
    public marketingURL: string = null;

    @Output()
    public restoreOrder: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('carrying')
    public carrying: HowCarryingComponent;

    @ViewChild('shipmentFrom')
    public shipmentFrom: ShipmentFromTabComponent;

    @Input() mainElement: ElementRef;

    public currentYear:string;

    modalRef: BsModalRef;
    public isQuotePage: boolean = false;

    constructor(public router: Router,
                public route: ActivatedRoute,
                private modalService: BsModalService,
                public googleTagService: GoogleTagService) {
        this.currentYear = new Date().getFullYear().toString();
    }

    public ngOnInit(): void {
        this.marketingURL = document.referrer;

        if (this.router.url.includes('importtype')) {
            this.firstPageHide = true;
            this.showFirstTab = false;

            this.route.params.subscribe((params: any) => {
                if (params['importtype'] == 'vehicle') {
                    this.order.Flag |= OrderOptions.IsVehicle;
                }

                if (params['product'] == 'product') {
                    if (this.order && this.order.Flag)
                        this.order.Flag &= ~OrderOptions.IsVehicle;
                }
            });
        }

        setTimeout(() => {
            this.googleTagService.pushData("import");
        }, 350)
    }

    public setOrderItem(event: OrderItem): OrderItem {
        return this.orderItem = event;
    }

    public setImportType(importerType: ImporterType): void {
        this.googleTagService.pushData("country");

        let prevImporterType = CalculatorHelper.checkOrderImporterType(this.order);
        if (prevImporterType === undefined) {
            prevImporterType = importerType;
        }

        if (importerType !== prevImporterType) {
            if (this.order.OrderItems.length > 0)
                this.order.OrderItems[0].Price = null;
            else
                this.orderItem.Price = null;
        }

        switch (importerType) {
            case ImporterType.Vehicle:
                this.order.Flag |= OrderOptions.IsVehicle;
                break;
            case ImporterType.Product:
                if (this.order && this.order.Flag)
                    this.order.Flag &= ~OrderOptions.IsVehicle;
                break;
            case ImporterType.Enterprise:
                // TODO for now nothing;
                return;
            case ImporterType.Regular:
                // TODO for now nothing;
                return;
        }

        FormHelper.scrollToTopCalcV2();
        FormHelper.scrollToCalcV2TabOnMobile();
        this.firstPageHide = true;
    }

    public createNewOrder(order: Order) {
        this.order = order;
    }

    public restoreWizard(): void {
        this.showWizard = false;
        this.order = new Order();
        this.orderItem = new OrderItem();
        this.showFirstTab = true;
        this.restoreOrder.emit(true);

        setTimeout(() => {
            this.showWizard = true;

            if (this.mainElement)
                this.mainElement.nativeElement.scrollTop = 0;
        }, 150);
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/public-calculator-v2.component.ts